var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetailIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.296,
    height: 18.34,
    viewBox: "0 0 19.296 18.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21874",
    "data-name": "\\uADF8\\uB8F9 21874",
    transform: "translate(-510.585 -2306.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10317",
    "data-name": "\\uD328\\uC2A4 10317",
    d: "M18.366,11.5,7.578,1.939C5.188.51,3.718.9,2.335,1.849a3.244,3.244,0,0,0-.264,5.033L13.146,17.045c.822.738,2.9,1.2,4.047.036,1.128-1.137,1.194-2.407.372-3.145L9.006,6.251",
    transform: "translate(510.385 2306.346)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10318",
    "data-name": "\\uD328\\uC2A4 10318",
    d: "M16.687,14.027a1.563,1.563,0,0,0-2.029-.091,1.206,1.206,0,0,0,.1,1.822l5.031,4.518",
    transform: "translate(502.7 2298.577)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailIcon4);
export default __webpack_public_path__ + "static/media/DetailIcon4.ca5f4d1fb2c04dc6901512b10b7aa3f2.svg";
export { ForwardRef as ReactComponent };